var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 74.82,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fillRule: "evenodd",
    d: "m-15.8958,43.9c5.49,-3.55 5.47,-7.5 0,-10.64l-42.93,-31.4c-4.45,-2.8 -9.12,-1.15 -9,4.69l0.18,61.68c0.38,6.34 4,8.07 9.33,5.14l42.42,-29.47zm53.91,-43.9l13.1,0a4,4 0 0 1 3.94,3.94l0,66.94a4,4 0 0 1 -3.94,3.94l-13.1,0a4,4 0 0 1 -3.94,-3.94l0,-66.94a4,4 0 0 1 3.94,-3.94zm-33.9,0l13.06,0a4,4 0 0 1 4,3.94l0,66.94a4,4 0 0 1 -4,3.94l-13.06,0a4,4 0 0 1 -3.94,-3.94l0,-66.94a4,4 0 0 1 3.94,-3.94z",
    className: "cls-1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f73642cafb890bb90a20b6365fd8ae52.svg";
export { ForwardRef as ReactComponent };